import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next'; // Add this import
import { Section4Icon } from 'icons';

export const Section4 = () => {
  const { t } = useTranslation(); // Hook for translations

  return (
    <>
      <Helmet>
        <title>Where We Operate — Sonnen Raffstoren</title>
        <meta
          name="description"
          content="Discover where Sonnen Raffstoren GmbH operates across Switzerland and how our local presence supports fast service and expert installations. We serve residential, commercial and public sector clients with high-quality external blinds, offering tailored consultation and professional installation in multiple regions. Our local teams understand regional climate demands and collaborate with architects and contractors to ensure smooth project delivery. We prioritize reliable after-sales support, maintenance and warranty services to keep systems functioning optimally. Learn about our commitment to quality workmanship, transparent pricing and sustainable product choices that improve comfort and energy efficiency while preserving the architectural integrity of each building."
        />
      </Helmet>
      <section className="flex flex-col md:flex-row items-center px-smallPx md:px-mediumPx lg:px-largePx xl:px-[200px] xl:h-[530px] md:space-y-0 space-y-5 md:space-x-10 space-x-0 py-20">
        <div className="py-10 md:py-0">
          <Section4Icon />
        </div>
        <div className="space-y-5 pb-10 md:pb-0">
          <div>
            <h1 className="text-[32px] font-[700] text-[#1E90AA]">
              {t('section4.whereWeOperate.title')}
            </h1>
            <p className="md:ml-5 text-justify md:text-left">
              {t('section4.whereWeOperate.description')}
            </p>
          </div>
          <div>
            <h1 className="text-[32px] font-[700] text-[#1E90AA]">
              {t('section4.whyChooseUs.title')}
            </h1>
            <div className="md:ml-5 text-justify md:text-left">
              {t('section4.whyChooseUs.description')}
              <ul className="list-disc list-inside">
                <li>{t('section4.whyChooseUs.list.expertConsultation')}</li>
                <li>{t('section4.whyChooseUs.list.seamlessInstallation')}</li>
                <li>{t('section4.whyChooseUs.list.afterSalesSupport')}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Section4;
